<template>
    <div class="course-management">
        <div class="flex ai-c col-4">
            <el-input v-model="query.condition.classname" class="mr-10" size="medium" clearable placeholder="班级名称"></el-input>
            <el-input v-model="query.condition.name" class="mr-10" size="medium" clearable placeholder="课程名称"></el-input>
            <div class="flex ai-c">
                <el-button @click="() => getCourseList(query)" type="primary" icon="el-icon-search">搜索</el-button>
                <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
            </div>
        </div>
        <el-table :data="courseList" v-loading="loading" border class="table-fixed-col mt-20">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="班级名称" prop="classname" key="classname" fixed min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="课程名称" prop="name" key="name" fixed min-width="200" show-overflow-tooltip>
                <span @click="() => $router.push({ name: 'CourseDetail', query: { code: row.code, classCode: row.classcode } })" slot-scope="{ row }" class="color-primary pointer">{{ row.name }}</span>
            </el-table-column>
            <el-table-column label="学员总数" prop="totalstudentcount" key="totalstudentcount" min-width="80" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="课程进展" prop="studyprocess" key="studyprocess" min-width="80" align="center" show-overflow-tooltip>
                <span slot-scope="{ row }">{{ `${row.finishperiodcount}/${row.periodcount}` }}</span>
            </el-table-column>
            <el-table-column label="总学习人数" prop="studystudentcount" key="studystudentcount" min-width="80" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="完成情况" prop="completeinfo" key="completeinfo" min-width="80" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="queryCache.page"
            background
        ></el-pagination>
        <CourseDetails :visible.sync="detailsVisible" :code="activeCode" />
    </div>
</template>
<script>
import CourseDetails from './components/courseDetails.vue'
import { getCourseList } from '@/api/measApi/studyManagement'
import { deepClone } from '@/common/js/tools'
export default {
    components: {
        CourseDetails,
    },
    data: () => ({
        activeCode: '',
        loading: false,
        detailsVisible: false,
        courseList: [],
        total: 0, // 查询数据量
        // 请求参数
        query: {
            condition: {
                classname: '',
                name: '',
            },
        },
        // 请求参数缓存
        queryCache: {
            page: 1,
            pagesize: 20,
        },
    }),
    created() {
        Object.assign(this.queryCache, deepClone(this.query))
        this.getCourseList()
    },
    methods: {
        // 重置搜索条件
        reset() {
            this.query.condition.classname = ''
            this.query.condition.name = ''
            this.getCourseList(this.query)
        },
        // 获取课程列表
        async getCourseList(param) {
            if (param) {
                this.queryCache.page = 1
            }
            Object.assign(this.queryCache, deepClone(param))
            this.loading = true
            try {
                const res = await getCourseList(this.queryCache)
                if (res.code === '000') {
                    this.courseList = res.data
                    this.total = res.pageinfo.rowcount
                }
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        openCourseDetails(code) {
            this.detailsVisible = true
            this.activeCode = code
        },
        // 序号格式化
        indexFormatter(index) {
            return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.queryCache.page = 1
            this.queryCache.pagesize = e
            this.getCourseList()
        },
        // 页面跳转
        curPageChange(e) {
            this.queryCache.page = e
            this.getCourseList()
        },
    },
}
</script>
<style lang="scss" scoped>
.course-management {
    .el-input {
        height: 36px;
    }
    .el-button {
        height: 36px;
        min-width: 0;
    }
}
</style>
